// Shared Forms Functionality for All Themes
// This file provides common form handling across all templates
// Handles both 'contact-form' and 'cta-contact-form' classes

document.addEventListener('DOMContentLoaded', function () {

    // Contact Form Handler - Use event delegation to handle both existing and dynamically created forms
    document.addEventListener('submit', function(e) {
        // Check if the submitted form has either contact-form or cta-contact-form class
        if (!e.target || (!e.target.classList.contains('contact-form') && !e.target.classList.contains('cta-contact-form'))) {
            return; // Not a contact form, let it submit normally
        }
        
        // Handle both regular contact forms and CTA modal forms
        var contactForm = e.target;
            e.preventDefault();
            
            // Validate form before submission
            if (!validateContactForm(contactForm)) {
                return false;
            }
            
            var submitButton = contactForm.querySelector('button[type="submit"], input[type="submit"]');
            var originalButtonText = submitButton ? submitButton.textContent || submitButton.value : '';

            // Show loading state
            if (submitButton) {
                submitButton.disabled = true;
                if (submitButton.tagName === 'BUTTON') {
                    submitButton.textContent = 'Sending...';
                } else {
                    submitButton.value = 'Sending...';
                }
            }

            // Get submit URL from data attribute instead of form action
            var submitUrl = contactForm.dataset.submitUrl;

            var formData = {};
            var formElements = contactForm.elements;

            for (var i = 0; i < formElements.length; i++) {
                var element = formElements[i];
                if (element.name && element.type !== 'submit' && element.type !== 'button') {
                    if (element.type === 'checkbox') {
                        formData[element.name] = element.checked;
                    } else if (element.type === 'radio') {
                        if (element.checked) {
                            formData[element.name] = element.value;
                        }
                    } else {
                        formData[element.name] = element.value;
                    }
                }
            }

            // Convert CakePHP form structure (data[Contact][field]) to nested object
            var structuredData = {};
            for (var fieldName in formData) {
                // Parse CakePHP field names like "data[Contact][name]" into nested structure
                if (fieldName.indexOf('data[Contact][') === 0) {
                    var actualFieldName = fieldName.replace('data[Contact][', '').replace(']', '');
                    if (!structuredData.Contact) {
                        structuredData.Contact = {};
                    }
                    structuredData.Contact[actualFieldName] = formData[fieldName];
                } else {
                    // Handle any non-Contact fields (like honeypot fields)
                    structuredData[fieldName] = formData[fieldName];
                }
            }

            // Make AJAX request with JSON data
            fetch(submitUrl, {
                method: 'POST',
                body: JSON.stringify(structuredData),
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    if (data.success) {
                        // Show success message from the server, if it exists, otherwise use default message
                        showMessage(contactForm, data.message || 'Thank you! Your message has been sent successfully.', 'success');

                        contactForm.reset();
                        // Fallback: manually clear form fields if reset() doesn't work
                        var formFields = contactForm.querySelectorAll('input, textarea, select');

                        formFields.forEach(function(field) {
                            if (field.type === 'checkbox' || field.type === 'radio') {
                                field.checked = false;
                            } else {
                                field.value = '';
                            }
                        });
                    } else {
                        // Show error message from the server, if it exists, otherwise use default message
                        showMessage(contactForm, data.message || 'An error occurred. Please try again.', 'error');
                    }
                })
                .catch(error => {
                    showMessage(contactForm, 'An error occurred. Please try again.', 'error');
                })
                .finally(() => {
                    // Reset button state
                    if (submitButton) {
                        submitButton.disabled = false;
                        if (submitButton.tagName === 'BUTTON') {
                            submitButton.textContent = originalButtonText;
                        } else {
                            submitButton.value = originalButtonText;
                        }
                    }
                });
    });

    // form validation
    function validateContactForm(form) {
        
        // Get the error message element inside the form
        var errorMessageElement = form.querySelector('.error-message');
        
        // Check if it exists
        if (!errorMessageElement) {
            return true; // Allow submission if no error element found
        }

        var valid = true;
        var errorMessageText = '';
        errorMessageElement.innerHTML = '';
        errorMessageElement.classList.remove('active');

        // Name Validation: Must contain two words
        var nameField = form.querySelector('input[name="name"], input[name="ContactName"], #ContactName', 'name="data[Contact][name]');
        if (nameField) {
            var name = nameField.value.trim();
            if (name === '' || name.split(' ').length < 2) {
                valid = false;
                errorMessageText += "Please enter both First and Last name.<br>";
            }
        }

        // Phone Validation: Must be at least 7 digits and no letters
        var phoneField = form.querySelector('input[name="phone"], input[name="ContactPhone"], #ContactPhone', 'name="data[Contact][phone]"');
        if (phoneField) {
            var phone = phoneField.value.trim();
            if (phone !== '') {
                var digitsOnly = phone.replace(/[^\d]/g, '');
                if (digitsOnly.length < 7 || /[a-zA-Z]/.test(phone)) {
                    valid = false;
                    errorMessageText += "Phone number must contain at least 7 digits and no letters. Allowed characters: ( ), +, -.<br>";
                }
            }
        }

        // Email Validation: Must be valid email format
        var emailField = form.querySelector('input[name="email"], input[name="ContactEmail"], #ContactEmail', 'name="data[Contact][email]"');
        if (emailField) {
            var email = emailField.value.trim();
            if (email !== '') {
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email)) {
                    valid = false;
                    errorMessageText += "Please enter a valid email address.<br>";
                }
            }
        }

        // Message Validation: At least 10 characters
        var messageField = form.querySelector('textarea[name="message"], textarea[name="ContactMessage"], #ContactMessage', 'name="data[Contact][message]"');
        if (messageField) {
            var message = messageField.value.trim();
            if (message.length < 10) {
                valid = false;
                errorMessageText += "Message must be at least 10 characters long.<br>";
            }
        }

        if (!valid) {
            // Show error messages
            errorMessageElement.innerHTML = errorMessageText;
            errorMessageElement.classList.add('active');
            return false;
        } else {
            // Clear any error messages
            errorMessageElement.classList.remove('active');
            errorMessageElement.innerHTML = '';
            return true;
        }
    }

    // Show message function
    function showMessage(form, message, type) {
        
        // Find the existing message element within the form
        var messageElement = form.querySelector(type === 'success' ? '.success-message' : '.error-message');
        
        if (!messageElement) {
            return;
        }
        
        // Clear any existing messages first
        var allMessageElements = form.querySelectorAll('.success-message, .error-message');
        allMessageElements.forEach(function(element) {
            element.classList.remove('active');
            element.innerHTML = '';
        });
        
        // Update the target message element
        messageElement.innerHTML = message;
        messageElement.classList.add('active');
        
        // Auto-remove success messages after 5 seconds
        if (type === 'success') {
            setTimeout(function() {
                if (messageElement.classList.contains('active')) {
                    messageElement.style.transition = 'opacity 0.5s ease';
                    messageElement.style.opacity = '0';
                    setTimeout(function() {
                        messageElement.classList.remove('active');
                        messageElement.innerHTML = '';
                        messageElement.style.opacity = '';
                    }, 500);
                }
            }, 5000);
        }
    }
});
